import {
  selectTradeInBrandBySlug,
  selectTradeInBrandSelectedValue,
} from 'store/widgets/TradeInNewCalculator/brand/selectors';
import {
  selectTradeInCapacityBySlug,
  selectTradeInCapacitySelectedValue,
} from 'store/widgets/TradeInNewCalculator/capacity/selectors';
import {
  selectTradeInTypeBySlug,
  selectTradeInTypeSelectedValue,
} from 'store/widgets/TradeInNewCalculator/deviceType/selectors';
import {
  selectTradeInModelBySlug,
  selectTradeInModelSelectedValue,
} from 'store/widgets/TradeInNewCalculator/model/selectors';

export const selectDataForTradeInAnalytics = (state) => {
  const deviceType = selectTradeInTypeSelectedValue(state);
  const brand = selectTradeInBrandSelectedValue(state);
  const model = selectTradeInModelSelectedValue(state);
  const capacity = selectTradeInCapacitySelectedValue(state);
  const typeBySlug = selectTradeInTypeBySlug(state);
  const brandBySlug = selectTradeInBrandBySlug(state);
  const modelBySlug = selectTradeInModelBySlug(state);
  const capacityBySlug = selectTradeInCapacityBySlug(state);

  return {
    deviceType: typeBySlug[deviceType]?.label,
    brand: brandBySlug[brand]?.label,
    model: modelBySlug[model]?.label,
    capacity: capacityBySlug[capacity]?.label,
  };
};
